import script from "./StaffShift.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffShift.vue?vue&type=script&setup=true&lang=js"

import "./StaffShift.vue?vue&type=style&index=0&id=900f5e48&lang=scss"

const __exports__ = script;

export default __exports__